module.exports = __webpack_public_path__ + "img/emo_03.4b9d9d73.png";